import { Form, Input as InputAntd, Radio, RadioChangeEvent, Select, Spin } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import TextArea from 'antd/lib/input/TextArea';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { NavLink, useNavigate } from 'react-router-dom';
import Button from '../../../components/Button/Button';
import DatePicker from '../../../components/DatePicker/DatePicker';
import Input from '../../../components/Input/Input';
import { Book as BookModel } from '../../../models/books';
import { createBook, createBookByGoogleId, getAllBookFromGoogle, getBookByGoogleId } from '../../../service/book';
import { addNewMeet } from '../../../service/meet';
import { createErrorNotification, createSuccessNotification } from '../../../service/notification';

import { getClubIdByPathname, getClubNameByPathname, getFormattedClubName, navigateToClub } from '../../../utils/club';
import styles from './AddMeet.module.scss';
import { Book } from './Book/Book';
import useHeader from '../../../hooks/useHeader';

const { Search } = InputAntd;

const times = [
  { value: 30, label: '30 minutos'},
  { value: 60, label: '1 hora'},
  { value: 90, label: '1 hora e 30 minutos'},
  { value: 120, label: '2 horas'},
  { value: 180, label: '3 horas'},
]

const AddMeet = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [ bookSelected, setBookSelected ] = useState<string | null>(null);
  const [ bookId, setBookId ] = useState<number | null>(null);
  const [dateMeet, setDateMeet ] = useState<string | null>(null);

  useHeader({ header: getFormattedClubName(), subheader: 'Cadastro de Encontro' });

  const [searchState, setSearchState] = useState('');
  
  const clubId = getClubIdByPathname();
  const clubName = getClubNameByPathname();
  
  const {data, isFetching: isFetchingBooks} = useQuery(
    ['books'],
    () => getAllBookFromGoogle(searchState),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false, enabled: !!searchState},
  );

  useEffect(() => {
    if(!bookSelected) return;
    if(bookId) return;

    const bookSelectedParse = JSON.parse(bookSelected) as BookModel;

    async function createNewBook(book: BookModel):Promise<number>{
      const {error, success} = await createBookByGoogleId(book.idGoogle);
      
      if(success) return success.id;
  
      const {error:errorBook, success:newBook} = await createBook(book)
  
      if(newBook) return newBook.id;
  
      if(error || errorBook) createErrorNotification(errorBook);
    }

    async function getBookId(book:BookModel):Promise<number>{
      if(book.id) return book.id;

      const {error, success} = await getBookByGoogleId(book.idGoogle);
  
      if(success) return success.id;

      return await createNewBook(book)
    }

    getBookId(bookSelectedParse)
      .then(bookId => {
        if(!bookId) return
        setBookId(bookId)
      })
      .catch(error => {
        console.log(error);
      })

  },[bookId, bookSelected])

  const onChangeBook = async (e: RadioChangeEvent) => {
    setBookSelected(e.target.value);
  }

  return(
    <div className={styles.container}>
      <div className={styles.maskContainer}></div>
        <div className={styles.createContainer}>
          <div className={styles.createForm}>
            <Form 
              layout="vertical"
              form={form}
              onFinish={async (values)=> {
                if(isLoading) return

                setIsLoading(true)

                values.bookId = bookId;
                values.dateMeet = dateMeet;

                delete values.bookName;

                console.log("Valores: ", values);

                const {error, success} = await addNewMeet(clubId, values);
                
                setIsLoading(false)

                if(error) return createErrorNotification(error)
            
                createSuccessNotification(success)
                
                navigate(navigateToClub(clubName,clubId, '/meets'), { replace: true })
              }} 
              id="formLogin" 
              className={styles.FormContainer}
            >
              <h2 className={styles.title}>Criar novo encontro</h2>
              {
                !bookSelected && <FormItem
                  label="Livro"
                  name="bookName"
                  rules={[
                    {
                      required: true, 
                      message: 'Por favor, escolha um livro'
                    }]
                  }
                  >
                  <Spin spinning={isFetchingBooks} >
                    <Search
                      placeholder="Search Book"
                      allowClear
                      size="large"
                      onSearch={value => setSearchState(value)}
                    />
                  </Spin>
                </FormItem>
              }
              {
                !bookSelected &&
                <Radio.Group 
                  onChange={onChangeBook} 
                  className={styles.list}>
                  {data?.map((book, index) => 
                    <Radio key={index} value={JSON.stringify(book)}>
                        <Book book={book} />
                    </Radio>
                  )}
                </Radio.Group>
              }
              {
                bookSelected && 
                  <div className={styles.bookSelected}><Book style={{maxHeight: '15rem', marginBottom: '10px'}} book={JSON.parse(bookSelected)}/></div>
              }
              <div className={styles.linkNewBook}>
                <NavLink 
                  to={'/book/add'}>
                    Não encontrou o livro que procura? clique aqui pra cadastrar.
                </NavLink>
              </div>
              <FormItem
                label="Data do encontro"
                name="dateMeet"
                rules={[{required: true, message: 'Por favor, insira a data e a hora!'}]}
                >
                  <DatePicker
                    showTime={{ format: 'HH:mm' }}
                    format="DD/MM/YYYY HH:mm"
                    onChange={(value, string) => {
                      setDateMeet(string)
                      return string
                    }}
                  />
              </FormItem>
              <FormItem
                label="Duração"
                name="duration"
                className={styles.select}
                rules={[
                  {
                    required: true, 
                    message: 'Por favor, insira a duração!'
                  }
                ]}
                >
                  <Select 
                    options={times} 
                    fieldNames={{label: 'label', value: 'value'}}/>
                </FormItem>
                <FormItem
                  label="Link"
                  name="link"
                >
                  <Input style={styles.input}/>
                </FormItem>
                <FormItem
                  label="Localização"
                  name="location"
                >
                  <Input style={styles.input} />
                </FormItem>
                <FormItem
                  label="Notas"
                  name="notes"
                >
                  <TextArea/>
                </FormItem>
                <Button submit style={styles.button}>Criar encontro</Button>
              </Form>
            </div>
        </div>
    </div>
  )
}

export default AddMeet;